import React, { useContext, useState } from 'react';

import { Button } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import { getApi } from '../../../api';
/** Mobx state store */
import BookingStoreContext from '../../../stores/bookingStore';
import BookingMessageDialog from '../../../components/bookingMessageDialog';

const ActionBooking = ({ status, role, userId, bookingId, onAction, rate, isOwner, driverId }) => {
  const bookingStore = useContext(BookingStoreContext);
  const [openMessage, setOpenMessage] = useState(false);

  const handleCloseBooking = async status => {
    onAction(true);
    const response = await getApi().put(`/users/${userId}/bookings/${bookingId}`, { status: status });

    if (response.status === 200) {
      bookingStore.setValue('isLoading', true);
    }
    onAction(false);
  };

  const canCancel = () => {
    return !['collaborator', 'driver'].find( f => f === role);
  }

  const canComplete = () => {
    return 'collaborator' !== role;
  }

  const canSendMessage = () => {
    return !!['collaborator', 'driver'].find( f => f === role) && status === 'approved';
  }

  const handleCloseMessageDialog = () => {
    setOpenMessage(false);
  }

  const handleSendMessageDialog = async (message) => {
    onAction(true);
    const params = {
      sender_id: message.users.sender,
      recipient_id: message.users.receiver,
      body: message.message
    };
    const response = await getApi().post(`/bookings/${bookingId}/messages`, { message: params });

    if (response.status === 200) {
      bookingStore.setValue('isLoading', true);
    }
    onAction(false);
    handleCloseMessageDialog();
  }

  return (
    <>
      {status === 'approved' && canCancel() && (
        <>
          <Button
            color="secondary"
            onClick={() => {
              handleCloseBooking('cancelled');
            }}
          >
            Cancelar
          </Button>
          </>
      )}
      {status === 'approved' && canComplete() && (
        <Button
          color="primary"
          onClick={() => {
            handleCloseBooking('completed');
          }}
        >
          Completar
        </Button>
      )}
      {role === 'collaborator' && (status === 'approved' || status === 'requested') && (
        <Button
          color="secondary"
          onClick={() => {
            handleCloseBooking('cancelled');
          }}
        >
          Cancelar
        </Button>
      )}
      {canSendMessage() && (
        <>
          <Button
            color="secondary"
            onClick={() => {
              setOpenMessage(true);
            }}
          >
            Mensaje
          </Button>
          <BookingMessageDialog open={openMessage} 
            labels={{title: 'Mensajería', message: 'Agregue su mensaje', closeLabel: 'Cancelar', confirmLabel: 'Enviar'}}
            users={{sender: isOwner ? userId : driverId, receiver: isOwner ? driverId : userId }}
            onClose={handleCloseMessageDialog}
            onConfirm={handleSendMessageDialog}
          />
        </ >
      )}
      
      { status === 'completed' && role !== 'driver' && (
        <Rating
          name="customized-empty"
          value={rate.ratingValue}
          precision={0.5}
          size="small"
          readOnly
          emptyIcon={<StarBorderIcon fontSize="inherit" />}
        />
        
      )}
    </>
  );
};

export default ActionBooking;
